import { useCallback, useState } from 'react'

import { clampDrawerWidth, DRAWER_DEFAULT_WIDTH } from './resizable-drawer.config'

interface UseResizableDrawerWidthReturn {
  drawerWidth: number
  handleResize: (deltaX: number) => void
}

/**
 * Manages drawer width state with resize clamping.
 * Extracts the common width + resize logic used by resizable drawers.
 */
export const useResizableDrawerWidth = (): UseResizableDrawerWidthReturn => {
  const [drawerWidth, setDrawerWidth] = useState(DRAWER_DEFAULT_WIDTH)

  const handleResize = useCallback(
    (deltaX: number): void => setDrawerWidth((prev) => clampDrawerWidth(prev - deltaX)),
    []
  )

  return { drawerWidth, handleResize }
}
